import { r as n } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { a as p } from "./tss-DN0acMKN.mjs";
function m(t) {
  const {
    theme: e,
    name: o,
    props: r
  } = t;
  return !e || !e.components || !e.components[o] || !e.components[o].defaultProps ? r : n(e.components[o].defaultProps, r);
}
function f({
  props: t,
  name: e,
  defaultTheme: o,
  themeId: r
}) {
  let s = p(o);
  return r && (s = s[r] || s), m({
    theme: s,
    name: e,
    props: t
  });
}
export {
  m as g,
  f as u
};
//# sourceMappingURL=useThemeProps-wW47KG21.mjs.map
